import React, { useState } from "react";
import { usersApi, apiErrorMessage } from "@/api/client";
import { Sheet } from "@/components/Sheet";
import { toast } from "sonner";

export function HomeLocationDialog({ open, onOpenChange }) {
  const [postcode, setPostcode] = useState("");
  const [label, setLabel] = useState("");
  const [saving, setSaving] = useState(false);

  React.useEffect(() => {
    if (open) {
      usersApi.getHomeLocation().then((r) => {
        setPostcode(r.data.home_location?.postcode || "");
        setLabel(r.data.home_location?.label || "");
      }).catch(() => {});
    }
  }, [open]);

  const save = async () => {
    setSaving(true);
    try {
      await usersApi.setHomeLocation({ postcode: postcode || null, label: label || null });
      toast.success("Home base saved (private to you)");
      onOpenChange(false);
    } catch (e) { toast.error(apiErrorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <Sheet open={open} onClose={() => onOpenChange(false)} title="Home base" testid="home-location-dialog">
      <p className="mb-3 text-xs text-slate-500">Strictly private — only you (and a super admin) can see this. Used to plan field days.</p>
      <label className="mb-1 block text-xs font-semibold text-slate-600">Label</label>
      <input data-testid="home-label-input" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Home"
        className="mb-3 min-h-[44px] w-full rounded-lg border border-slate-200 px-3 text-sm" />
      <label className="mb-1 block text-xs font-semibold text-slate-600">Postcode</label>
      <input data-testid="home-postcode-input" value={postcode} onChange={(e) => setPostcode(e.target.value)} placeholder="BS1 4DJ"
        className="mb-4 min-h-[44px] w-full rounded-lg border border-slate-200 px-3 text-sm" />
      <button data-testid="home-save" onClick={save} disabled={saving}
        className="min-h-[48px] w-full rounded-lg bg-teal-700 font-semibold text-white hover:bg-teal-800 disabled:opacity-60">
        {saving ? "Saving…" : "Save home base"}
      </button>
    </Sheet>
  );
}
